/* eslint-disable no-console */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-multi-comp */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  LayersControl,
  Marker,
  Pane,
  GeoJSON,
  Polyline,
  Tooltip
} from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';
import { Fab, FormControlLabel, Checkbox, Button } from '@mui/material';
import { Menu } from '@mui/icons-material';

import L from 'leaflet';

// Util
import { addMeteresToLat, addMeteresToLng } from './util';
import { parseGeoJson } from '../../utils/parsingUtils';
import { indexPriority, geofenceColor } from 'utils/ui';

// Actions
import {
  createRoute,
  updateRoute,
  setNewGeoJson,
  setUpdateGeoJson,
  toggleNewLineAndPoints,
  closeDeleteConfirm,
  deleteRoute,
  getElevation,
  clearNewRoute,
  clearUpdateRoute,
  setTab,
  setNewRouteElevationPoints,
  setNewRouteStartPointElevation,
  setNewRouteStartPoint,
  setUpdateRouteElevationPoints,
  setUpdateRouteStartPointElevation,
  setUpdateRouteStartPoint
} from 'actions/routePlannerActions';
import { setNavbar } from 'actions/uiActions';
import { getObstacles } from '../../actions/obstacleActions';
import { selectObstacleHex } from 'selectors/routePlannerSelectors';
// Components
import ElevationMarker from './components/ElevationMarker';
import Teleport from '../../components/Teleport';
import { DraggableCircle } from './components/DraggableCircle';

// Constants
import { balbrigganCoords } from '../../constants';
import { SET_DROP_LOCATION } from 'actions/actionTypes';
import { getGeofences } from 'actions/geofenceActions';
import { OBSTACLE_COLORS } from './ObstaclePlanner';
import { getLandingPads } from 'actions/liveAircraftActions';
import { selectObstacles } from 'reducers/obstaclesReducer';
import { selectSelectedCellId } from 'selectors/ordersSelector';
import { useAppSelector } from 'hooks/redux';
import {
  PreviousDropPointIcon,
  RouteStartMarker,
  CurrentDropPointIcon
} from '../Restaurant/components/MapIcons';

const { BaseLayer } = LayersControl;

const NEW_ROUTE = 0;
const UPDATE_ROUTE = 1;

const drawOptions = {
  marker: false,
  rectangle: false,
  circle: false,
  circlemarker: false,
  polyline: true,
  polygon: false
};

const RouteMap = props => {
  const [showElevation, setShowElevation] = useState();
  const {
    updateRoute,
    createRoute,
    setUpdateGeoJson,
    clearNewRoute,
    clearUpdateRoute,
    setNewGeoJson,
    tab,
    routeType,
    setNewRouteElevationPoints,
    newRouteElevationPoints,
    setNewRouteStartPointElevation,
    newRouteStartPointElevation,
    setNewRouteStartPoint,
    newRouteStartPoint,
    newRouteGeoJson,
    setUpdateRouteElevationPoints,
    updateRouteElevationPoints,
    setUpdateRouteStartPointElevation,
    updateRouteStartPointElevation,
    setUpdateRouteStartPoint,
    updateRouteStartPoint,
    updateRouteGeoJson,
    newRoute,
    newShowLine,
    setNavbar,
    navbarDesktopOpen,
    dropLocation,
    setDropLocation,
    geofences,
    getGeofences,
    activePads,
    getLandingPads
  } = props;
  const obstacles = useSelector(selectObstacles);
  const startPointRefNewRoute = useRef();
  const startPointRefUpdateRoute = useRef();
  const eircodeRef = useRef();
  const mapRef = useRef();
  const tabRef = useRef(tab);
  const drawFGRef = useRef();
  const dispatch = useDispatch();
  const cell = useAppSelector(selectSelectedCellId);
  useEffect(() => {
    dispatch(getObstacles(cell));
  }, [cell]);

  const clearStartPoint = () => {
    if (tabRef.current === NEW_ROUTE) {
      setNewRouteStartPoint(null);
      setNewRouteStartPointElevation(null);
      startPointRefNewRoute.current = null;
    } else {
      setUpdateRouteStartPoint(null);
      setUpdateRouteStartPointElevation(null);
      setDropLocation(null);
      startPointRefUpdateRoute.current = null;
    }
  };
    // Helper function to extract drop points from route data, necessary for rendering drop points on the map in both linestring and point mode
  const getDropPointsFromRoute = (route) => {
    if (!route) return [];
    
    const sources = [route.misc1, route.misc2].filter(Boolean); // remove falsy values (undefined, null...)
    
    return sources.flatMap(source => // flatten results prevent nested arrays 
      (source.features || [])
        .filter(feature => 
          feature.geometry?.type === 'Point' && 
          feature.properties?.type === 'drop'
        )
        .map(feature => ({
          coordinates: [
            feature.geometry.coordinates[1], 
            feature.geometry.coordinates[0]
          ], // [lat, lng]
          properties: feature.properties
        }))
    );
  };

  useEffect(() => {
    getGeofences();
  }, [getGeofences]);

  useEffect(() => {
    getLandingPads();
  }, [getLandingPads]);

  // Tab state is used in event listener
  // Must update using ref
  useEffect(() => {
    tabRef.current = tab;
  }, [tab]);

  useEffect(() => {
    if (drawFGRef.current) {
      const leafletFG = drawFGRef.current;
      try {
        // If tab is 0 parse newGeoJson string and map to leaflet elements
        const parsed =
          tab === NEW_ROUTE
            ? parseGeoJson(newRouteGeoJson)
            : parseGeoJson(updateRouteGeoJson);

        if (parsed) {
          let newLeafletGeoJson = new L.GeoJSON(parsed);
          leafletFG.clearLayers();
          newLeafletGeoJson.eachLayer(layer => {
            const { properties, geometry } = layer.feature;
            if (geometry.type === 'Point') {
              const popupContent = `<div>${Object.keys(properties).reduce(
                (acc, key) => acc + `<div>${key}:${properties[key]}</div>`,
                ''
              )}<div>Coords : ${geometry.coordinates}</div></div>`;
              const popup = L.popup().setContent(popupContent);
              const coords = L.latLng(
                geometry.coordinates[1],
                geometry.coordinates[0]
              );
              
              // Skip drop zones entirely - they're handled by dedicated rendering logic
              if (properties.type !== 'drop') {
                const circleMarker = L.circleMarker(coords, {
                  color: properties['marker-color'],
                  radius: 5,
                  fillColor: properties['marker-color'],
                  fillOpacity: 1
                });
                circleMarker.bindPopup(popup);
                leafletFG.addLayer(circleMarker);
              }
            } else {
              leafletFG.addLayer(layer);
            }
          });
          mapRef.current.fitBounds(leafletFG.getBounds());
        } else {
          leafletFG.clearLayers();
        }
      } catch (e) {
        console.log(e);
      }
    }
  }, [tab, updateRouteGeoJson, newRouteGeoJson, drawFGRef, mapRef]);

  useEffect(() => {
    if (newRoute) {
      if (newShowLine) {
        showEditButton(true);
        setNewGeoJson(JSON.stringify(newRoute.misc2, null, 2));
      } else {
        showEditButton(false);
        setNewGeoJson(JSON.stringify(newRoute.misc1, null, 2));
      }
    }
  }, [newShowLine, newRoute, setNewGeoJson]);

  useEffect(() => {
    showEditButton(true);
    setShowElevation(false);
  }, [tab]);

  useEffect(() => {
    startPointRefNewRoute.current = newRouteStartPoint;
  }, [newRouteStartPoint]);

  useEffect(() => {
    if (updateRoute && updateRoute.misc2) {
      const lat = updateRoute.misc2.features[0].geometry.coordinates[0][1];
      const lng = updateRoute.misc2.features[0].geometry.coordinates[0][0];
      setStartPointAndGetElevation(lat, lng);
    } else {
      clearStartPoint();
    }
  }, [updateRoute]);

  useEffect(() => {
    if (showElevation) {
      const southWest = mapRef.current.leafletElement
        .getBounds()
        .getSouthWest();

      // 40 x 100m = 4km
      const pointsLengthX = 40;
      const pointsLengthY = 40;

      let lng = southWest.lng;
      let lat = southWest.lat;

      let boundedPoints = [];

      for (var y = 0; y < pointsLengthY; y++) {
        if (y !== 0) lat = addMeteresToLat(100, lat);
        for (var x = 0; x < pointsLengthX; x++) {
          if (x !== 0) lng = addMeteresToLng(100, lng, lat);
          boundedPoints.push({ lat, lng });
        }
        lng = southWest.lng;
      }

      const batches = splitBoundedPointsToBatches(boundedPoints);
      const batchesRequests = requestBatchedElevation(batches);

      Promise.all(batchesRequests).then(res => {
        let elevationPoints = [];
        res.forEach(elRes => {
          elevationPoints = elevationPoints.concat(elRes.data.results);
        });
        tab === NEW_ROUTE
          ? setNewRouteElevationPoints(elevationPoints)
          : setUpdateRouteElevationPoints(elevationPoints);
      });
    } else {
      setNewRouteElevationPoints(null);
      setUpdateRouteElevationPoints(null);
    }
  }, [showElevation]);

  const showEditButton = show => {
    const editBtn = document.getElementsByClassName(
      'leaflet-draw-edit-edit'
    )[0];
    if (editBtn) {
      editBtn.style.display = show ? 'block' : 'none';
    }
  };

  const requestBatchedElevation = batches => {
    const requests = batches.map(batch => {
      const locationsQueryString = batch
        .reduce((acc, point) => acc + `${point.lat},${point.lng}|`, '')
        .slice(0, -1);
      return getElevation(locationsQueryString);
    });
    return requests;
  };

  const splitBoundedPointsToBatches = boundedPoints => {
    const batches = [];
    const quotient = Math.floor(boundedPoints.length / 100);
    const remainder = boundedPoints.length % 100;
    let slicePosition = 0;
    for (var i = 0; i < quotient; i++) {
      const batch = boundedPoints.slice(slicePosition, slicePosition + 100);
      batches.push(batch);
      slicePosition = i * 100;
    }
    if (remainder) {
      const remainingBatch = boundedPoints.slice(
        slicePosition,
        slicePosition + remainder
      );
      batches.push(remainingBatch);
    }
    return batches;
  };

  const setUpdateRoute = stringifiedUpdateGJson => {
    setUpdateGeoJson(stringifiedUpdateGJson);
  };

  const setStartPointAndGetElevation = (lat, lng) => {
    const latLng = { lat, lng };
    if (tabRef.current === NEW_ROUTE) {
      startPointRefNewRoute.current = latLng;
      setNewRouteStartPoint(latLng);
      getElevation(`${lat},${lng}`)
        .then(res => {
          setNewRouteStartPointElevation(res.data.results[0].elevation);
        })
        .catch(e => {
          console.log(e);
        });
    } else {
      startPointRefUpdateRoute.current = latLng;
      setUpdateRouteStartPoint(latLng);
      getElevation(`${lat},${lng}`)
        .then(res => {
          setUpdateRouteStartPointElevation(res.data.results[0].elevation);
        })
        .catch(e => {
          console.log(e);
        });
    }
  };

  const onEdit = e => {
    const gJson = e.layers.toGeoJSON(10);
    if (gJson.features.length > 0) {
      const formattedGJson = JSON.stringify(gJson, null, 2);
      if (tabRef.current === NEW_ROUTE) {
        setNewGeoJson(formattedGJson);
        if (eircodeRef.current)
          createRoute(eircodeRef.current, formattedGJson, routeType);
      } else {
        setUpdateRoute(formattedGJson);
      }
      const newStartPoint = gJson.features[0].geometry.coordinates[0];
      setStartPointAndGetElevation(newStartPoint[1], newStartPoint[0]);
    }
  };

  const onDelete = e => {
    if (tabRef.current === NEW_ROUTE) {
      clearNewRoute();
    } else {
      clearUpdateRoute();
    }
    clearStartPoint();
    setShowElevation(false);
  };

  const onDrawVertex = evt => {
    const noStartPointSetForNewRoute =
      tabRef.current === NEW_ROUTE && !startPointRefNewRoute.current;
    const noStartPointSetForUpdateRoute =
      tabRef.current === UPDATE_ROUTE && !startPointRefUpdateRoute.current;

    if (noStartPointSetForNewRoute || noStartPointSetForUpdateRoute) {
      const pointsGJson = evt.layers.toGeoJSON(10);
      const newStartingPoint = pointsGJson.features[0];
      const lng = newStartingPoint.geometry.coordinates[0];
      const lat = newStartingPoint.geometry.coordinates[1];
      setStartPointAndGetElevation(lat, lng);
    }
  };

  const onCreate = e => {
    const newFeature = e.layer.toGeoJSON(10);

    if (tabRef.current === NEW_ROUTE) {
      const existingRoute = JSON.parse(newRouteGeoJson);
      if (existingRoute.features[0]) {
        const mergedCoords = [
          ...existingRoute.features[0].geometry.coordinates,
          ...newFeature.geometry.coordinates
        ];
        const mergedCoordsFeature = {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              properties: {},
              geometry: { type: 'LineString', coordinates: mergedCoords }
            }
          ]
        };
        const formattedGJson = JSON.stringify(mergedCoordsFeature, null, 2);
        setNewGeoJson(formattedGJson);
      } else {
        const featureCollection = {
          type: 'FeatureCollection',
          features: [newFeature]
        };
        const formattedGJson = JSON.stringify(featureCollection, null, 2);
        setNewGeoJson(formattedGJson);
      }
    } else {
      const featureCollection = {
        type: 'FeatureCollection',
        features: [newFeature]
      };
      const formattedGJson = JSON.stringify(featureCollection, null, 2);
      setUpdateGeoJson(formattedGJson);
    }
  };

  const onCheckElevation = evt => {
    setShowElevation(evt.target.checked);
  };

  const renderElevationText = () => {
    if (tabRef.current === UPDATE_ROUTE) {
      return updateRouteStartPoint && updateRouteStartPointElevation
        ? `Elevation | Start point ${updateRouteStartPointElevation}m`
        : 'Elevation';
    } else if (tabRef.current === NEW_ROUTE) {
      return newRouteStartPoint && newRouteStartPointElevation
        ? `Elevation | Start point ${newRouteStartPointElevation}m`
        : 'Elevation';
    }
  };

  const toggleMenu = () => {
    setNavbar(!navbarDesktopOpen);
  };

  // Memoize drop points to avoid recalculating on every render
  const currentRoute = tab === NEW_ROUTE ? newRoute : updateRoute;
  const dropPoints = useMemo(() => getDropPointsFromRoute(currentRoute), [currentRoute]);

  return (
    <div className="relative">
      <MapContainer
        center={balbrigganCoords}
        style={{ height: '100vh', width: '100%', zIndex: 500 }}
        zoom={16}
        maxZoom={23}
        zoomControl={false}
        ref={mapRef}
        animate={false}>
        <TileLayer
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <LayersControl>
          <BaseLayer checked name="Manna v1">
            <TileLayer
              attribution="Manna-v1"
              url="https://tiles.manna.aero/{z}/{x}/{y}.png"
              maxZoom={24}
            />
          </BaseLayer>
          <BaseLayer name="Manna v2">
            <TileLayer
              attribution="Manna-v2"
              url="https://tiles-dev.manna.aero/{z}/{x}/{y}.png"
              maxZoom={24}
            />
          </BaseLayer>
        </LayersControl>
        {obstacles &&
          obstacles?.map(ob => {
            const color = OBSTACLE_COLORS[ob.groundRisk] || 'red';
            return (
              <GeoJSON
                data={ob.geoJson}
                style={() => ({
                  color,
                  weight: 2,
                  fillOpacity: 0.5
                })}
                key={Math.random() + 'xxxgeeeituerijfhy7er'}
              />
            );
          })}

        <Pane style={{ zIndex: indexPriority(7) }}>
          {geofences &&
            geofences.length > 0 &&
            geofences
              .filter(geofence => geofence.active === true)
              .map(geofence => {
                return (
                  <GeoJSON
                    data={geofence.geoJson}
                    style={{ fill: false, color: geofenceColor(geofence.id) }}
                    key={geofence.id}
                  />
                );
              })}
        </Pane>
        <FeatureGroup ref={drawFGRef}>
          <EditControl
            position="topright"
            onDrawVertex={onDrawVertex}
            onEdited={onEdit}
            onCreated={onCreate}
            onDeleted={onDelete}
            draw={drawOptions}
          />
        </FeatureGroup>
        {tab === NEW_ROUTE &&
          newRouteElevationPoints &&
          newRouteElevationPoints.map((elPoint, index) => {
            return (
              <ElevationMarker
                key={`newRouteElevation_${index}_${elPoint.elevation}`}
                position={[elPoint.latitude, elPoint.longitude]}
                className="p-2 bg-white text-center text-sm"
                text={elPoint.elevation}
                homeSurfaceAlt={newRouteStartPointElevation}
              />
            );
          })}
        {tab === UPDATE_ROUTE &&
          updateRoute &&
          updateRouteElevationPoints &&
          updateRouteElevationPoints.map((elPoint, index) => {
            return (
              <ElevationMarker
                position={[elPoint.latitude, elPoint.longitude]}
                key={`${index}_${elPoint.elevation}`}
                className="p-2 bg-white text-center text-sm"
                text={elPoint.elevation}
                homeSurfaceAlt={updateRouteStartPointElevation}
              />
            );
          })}
        {tab === NEW_ROUTE && newRouteStartPoint && (
          <Marker
            icon={RouteStartMarker}
            position={[newRouteStartPoint.lat, newRouteStartPoint.lng]}
            color="green"
          />
        )}
        {tab === UPDATE_ROUTE && updateRouteStartPoint && (
          <Marker
            icon={RouteStartMarker}
            position={[updateRouteStartPoint.lat, updateRouteStartPoint.lng]}
            color="green"
          />
        )}
        {activePads ? (
          activePads.map((pad, i) => {
            return (
              <Pane key={`pad-marker-${pad.id}`} name={`pad-marker-pane-${pad.id}-${i}`} style={{ zIndex: indexPriority(19) }}>
                <Marker
                  position={[pad.latitude, pad.longitude]}
                  icon={PreviousDropPointIcon}>
                  <Tooltip
                    permanent
                    direction="bottom"
                    opacity={0.6}
                    offset={[0, 10]}>
                    {pad.name}
                  </Tooltip>
                </Marker>
              </Pane>
            );
          })
        ) : (
          <></>
        )}
        
        {/* Always render drop points regardless of toggle state */}
        {((tab === NEW_ROUTE && newRoute) || (tab === UPDATE_ROUTE && updateRoute)) &&
          dropPoints.map((dropPoint, index) => (
            <Pane key={`drop-point-${tab}-${index}`} style={{ zIndex: indexPriority(20) }}>
              <Marker
                position={dropPoint.coordinates}
                icon={CurrentDropPointIcon}>
                <Tooltip
                  permanent
                  direction="bottom"
                  opacity={0.8}
                  offset={[0, 10]}>
                  Drop Zone
                </Tooltip>
              </Marker>
            </Pane>
          ))
        }
        
        {tab === UPDATE_ROUTE && updateRoute && (
          <Pane style={{ zIndex: indexPriority(9) }}>
            {updateRoute &&
              updateRoute?.misc2?.features?.length > 0 &&
              updateRoute?.misc2?.features.map(feature => {
                return (
                  <Polyline
                    positions={updateRoute?.misc2?.features?.[0]?.geometry?.coordinates?.map(
                      coord => [coord[1], coord[0]]
                    )}
                    key={`routecoords-${JSON.stringify(feature)}`}
                  />
                );
              })}
          </Pane>
        )}
        {tab === UPDATE_ROUTE && dropLocation && (
          <DraggableCircle
            center={[dropLocation.latitude, dropLocation.longitude]}
            radius={2.5}
            onDragEnd={({ lat, lng }) => {}}
            pathOptions={{ color: 'red' }}
          />
        )}
      </MapContainer>
      <div className="absolute top-2.5 left-2.5 z-50">
        <Fab
          color="primary"
          onClick={toggleMenu}
          className="mr-4">
          <Menu />
        </Fab>
        <Teleport
          ref={mapRef}
          btnProps={{ variant: 'contained', className: "mx-2" }}
        />
      </div>
      <FormControlLabel
        control={<Checkbox color="primary" />}
        disabled={
          tab === NEW_ROUTE ? !newRouteStartPoint : !updateRouteStartPoint
        }
        onChange={onCheckElevation}
        checked={showElevation}
        label={renderElevationText()}
        labelPlacement="end"
        className="absolute bg-white p-1 bottom-[22.5rem] left-6 z-50 pr-5 rounded-md"
      />
      <Button
        fullWidth
        style={{
          position: 'absolute',
          backgroundColor: 'white',
          padding: 3,
          bottom: 22.5,
          right: 6.25,
          zIndex: 60,
          width: 50,
          height: 12.5,
          borderRadius: 5,
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center'
        }}>
        Save Drop Location
      </Button>
    </div>
  );
};

const mapStateToProps = state => ({
  highway: state.routePlanner.highwayKey,
  creatingRoute: state.routePlanner.creatingRoute,
  newRouteGeoJson: state.routePlanner.newRouteGeoJson,
  updateRouteGeoJson: state.routePlanner.updateRouteGeoJson,
  updateRoute: state.routePlanner.updateRoute,
  newRoute: state.routePlanner.newRoute,
  newShowLine: state.routePlanner.newShowLine,
  deleteRouteConfirmModalOpen: state.routePlanner.openDeleteConfirm,
  deleteId: state.routePlanner.deleteId,
  deleteEircode: state.routePlanner.deleteEircode,
  deletingRoute: state.routePlanner.deletingRoute,
  tab: state.routePlanner.tab,
  routeType: state.routePlanner.routeType,
  newRouteElevationPoints: state.routePlanner.newRouteElevationPoints,
  newRouteStartPointElevation: state.routePlanner.newRouteStartPointElevation,
  newRouteStartPoint: state.routePlanner.newRouteStartPoint,
  updateRouteElevationPoints: state.routePlanner.updateRouteElevationPoints,
  updateRouteStartPointElevation:
    state.routePlanner.updateRouteStartPointElevation,
  updateRouteStartPoint: state.routePlanner.updateRouteStartPoint,
  navbarDesktopOpen: state.ui.navbarDesktopOpen,
  dropLocation: state.routePlanner.dropLocation,
  geofences: state.geofences.geofences,
  activePads: state.liveAircraft.activePads
});

const mapDispatchToProps = dispatch => ({
  setNewRouteElevationPoints: elevationPoints =>
    dispatch(setNewRouteElevationPoints(elevationPoints)),
  setNewRouteStartPointElevation: elevation =>
    dispatch(setNewRouteStartPointElevation(elevation)),
  setNewRouteStartPoint: startPoint =>
    dispatch(setNewRouteStartPoint(startPoint)),
  setUpdateRouteElevationPoints: elevationPoints =>
    dispatch(setUpdateRouteElevationPoints(elevationPoints)),
  setUpdateRouteStartPointElevation: elevation =>
    dispatch(setUpdateRouteStartPointElevation(elevation)),
  setUpdateRouteStartPoint: startPoint =>
    dispatch(setUpdateRouteStartPoint(startPoint)),
  createRoute: (eircode, lineString, name, routeModeDev, autoRelativeAlt) =>
    dispatch(
      createRoute(eircode, lineString, name, routeModeDev, autoRelativeAlt)
    ),
  sendUpdatedRoute: (eircode, lineString) =>
    dispatch(updateRoute(eircode, lineString)),
  setNewGeoJson: gJson => dispatch(setNewGeoJson(gJson)),
  setUpdateGeoJson: gJson => dispatch(setUpdateGeoJson(gJson)),
  toggleNewLineAndPoints: showLine =>
    dispatch(toggleNewLineAndPoints(showLine)),
  closeConfirmModal: () => dispatch(closeDeleteConfirm()),
  deleteRoute: (id, eircode) => dispatch(deleteRoute(id, eircode)),
  clearNewRoute: () => dispatch(clearNewRoute()),
  clearUpdateRoute: () => dispatch(clearUpdateRoute()),
  setTab: tab => dispatch(setTab(tab)),
  setNavbar: open => dispatch(setNavbar(open)),
  setDropLocation: dropLocation =>
    dispatch({ type: SET_DROP_LOCATION, payload: dropLocation }),
  getGeofences: () => dispatch(getGeofences()),
  getLandingPads: () => dispatch(getLandingPads())
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteMap);
